import { Loader2 } from "lucide-react";
import { ImageLoader } from "~/components/ImageLoader";

// // // //

type OAuthProviders = "google" | "microsoft" | "linkedin";

interface OAuthButtonContent {
    login_label: string;
    register_label: string;
    icon: string;
}

const googleButtonContent: OAuthButtonContent = {
    login_label: "Sign in with Google",
    register_label: "Sign up with Google",
    icon: "https://cdn.rwa.xyz/images/auth/google-logo.svg",
};

const microsoftButtonContent: OAuthButtonContent = {
    login_label: "Sign in with Microsoft",
    register_label: "Sign up with Microsoft",
    icon: "https://cdn.rwa.xyz/images/auth/microsoft-logo.svg",
};

const linkedinButtonContent: OAuthButtonContent = {
    login_label: "Sign in with LinkedIn",
    register_label: "Sign up with LinkedIn",
    icon: "https://cdn.rwa.xyz/images/auth/linkedin-logo.svg",
};

const providerToContent: Record<OAuthProviders, OAuthButtonContent> = {
    google: googleButtonContent,
    microsoft: microsoftButtonContent,
    linkedin: linkedinButtonContent,
};

export function OAuthButton(props: {
    disabled: boolean;
    loading: boolean;
    onClick: () => void;
    provider: OAuthProviders;
    variant: "login" | "register";
}) {
    const { provider, disabled, loading, onClick, variant } = props;

    const content = providerToContent[provider];
    const { icon } = content;
    const label =
        variant === "login" ? content.login_label : content.register_label;

    return (
        <button
            onClick={() => onClick()}
            disabled={disabled || loading}
            className="flex w-full cursor-pointer items-center justify-center gap-2 rounded-md border bg-card py-2 text-sm text-slate-700 shadow-sm transition-colors duration-200 sm:py-2.5 hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-50"
        >
            <span className="sr-only">{label}</span>

            {loading && (
                <Loader2
                    className="h-4 w-4 animate-spin sm:h-5 sm:w-5"
                    aria-hidden
                />
            )}

            {!loading && (
                <ImageLoader
                    className="h-4 w-4 sm:h-5 sm:w-5"
                    width={20}
                    height={20}
                    src={icon}
                    draggable={false}
                    alt="Google"
                />
            )}
            {label}
        </button>
    );
}
